import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const ViewModal = ({ show, handleClose }) => {

    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5 text-center">View Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Render row details */}
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Name</span>
                            <p class="">John Doe</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Email</span>
                            <p class="">daniel@example.com</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Password</span>
                            <p class="">michael@123</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Link</span>
                            <p class=""><a href="https://coderchaos.com">https://coderchaos.com</a></p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Added By</span>
                            <p class="">
                                <span class="badge bg-warning">Admin</span>
                            </p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Updated By</span>
                            <p class="">
                                <span class="badge bg-warning">User 1</span>
                            </p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Created At</span>
                            <p class="">
                                <span class="badge bg-info">2024-03-01T13:20:00</span>
                            </p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Updated At</span>
                            <p class="">
                                <span class="badge bg-info">2024-03-02T09:45:00</span>
                            </p>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ViewModal;